/* ==========================================================================
   nb-pages.js — adfaerd paa indholds- og servicesiderne (fase 6)

   Tre uafhaengige smaa moduler:
     1) Faner        [data-nb-tabs]            stoerrelsesguiden (og modalen)
     2) Formularer   [data-nb-validate]        kontaktformularens validering
     3) Cookies      [data-nb-cookie-reopen]   genaabner cookie-banneret

   INGEN tekst i denne fil. Alle beskeder laeses fra data-attributter, som
   Liquid fylder ud fra locales — praecis som nb-cart.js og nb-wishlist.js.

   Idempotent: filen kan indlaeses to gange, hvert element markeres naar det
   er bundet, og alt initieres igen paa 'shopify:section:load'.
   ========================================================================== */
(function () {
  'use strict';

  var BOUND = 'data-nb-bound';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function claim(el) {
    if (!el || el.hasAttribute(BOUND)) return false;
    el.setAttribute(BOUND, '');
    return true;
  }

  function scopeOf(root) {
    return root && root.querySelectorAll ? root : document;
  }

  /* ======================================================================
     1) Faner
     ----------------------------------------------------------------------
       <div data-nb-tabs data-nb-tabs-param="t">
         <div role="tablist">
           <button role="tab" data-nb-tab="costumes" data-nb-tab-key="kost">…</button>
         </div>
         <div role="tabpanel" data-nb-tabpanel="costumes">…</div>
       </div>

     data-nb-tabs-param (valgfri) laeser ?t=<key> fra URL'en, saa
     /pages/storrelsesguide?t=plak aabner plakat-fanen direkte — samme
     adfaerd som prototypen.
     ====================================================================== */

  function initTabs(root) {
    toArray(scopeOf(root).querySelectorAll('[data-nb-tabs]')).forEach(function (group) {
      if (!claim(group)) return;

      var tabs = toArray(group.querySelectorAll('[data-nb-tab]'));
      if (!tabs.length) return;

      function panelFor(tab) {
        var id = tab.getAttribute('data-nb-tab');
        return group.querySelector('[data-nb-tabpanel="' + id + '"]');
      }

      function select(tab, focus) {
        tabs.forEach(function (item) {
          var active = item === tab;
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.setAttribute('tabindex', active ? '0' : '-1');
          var panel = panelFor(item);
          if (panel) panel.hidden = !active;
        });
        if (focus) tab.focus();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          select(tab, false);
        });
        tab.addEventListener('keydown', function (event) {
          var key = event.key;
          var next = null;
          if (key === 'ArrowRight' || key === 'ArrowDown') next = tabs[(index + 1) % tabs.length];
          else if (key === 'ArrowLeft' || key === 'ArrowUp') next = tabs[(index - 1 + tabs.length) % tabs.length];
          else if (key === 'Home') next = tabs[0];
          else if (key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          event.preventDefault();
          select(next, true);
        });
      });

      /* Deep-link: ?t=<key> matcher data-nb-tab-key eller data-nb-tab. */
      var start = tabs[0];
      var param = group.getAttribute('data-nb-tabs-param');
      if (param) {
        var wanted = null;
        try {
          wanted = new URLSearchParams(window.location.search).get(param);
        } catch (e) {
          wanted = null;
        }
        if (wanted) {
          for (var i = 0; i < tabs.length; i++) {
            var keys = (tabs[i].getAttribute('data-nb-tab-key') || '') + ',' + tabs[i].getAttribute('data-nb-tab');
            if (keys.split(',').indexOf(wanted) !== -1) {
              start = tabs[i];
              break;
            }
          }
        }
      }
      select(start, false);
    });
  }

  /* ======================================================================
     2) Formular-validering
     ----------------------------------------------------------------------
       <form data-nb-validate novalidate>
         <div data-nb-form-errors role="alert" hidden
              data-nb-message="Tjek felterne herunder">…</div>
         <input data-nb-error-required="…" data-nb-error-email="…"
                aria-describedby="fejl-id" required>
         <span id="fejl-id" data-nb-field-error hidden></span>
       </form>

     Browserens egen boble er slaaet fra (novalidate), saa beskederne kan
     staa paa dansk fra locales og laeses op af skaermlaesere via aria-live.
     Uden JS falder formularen tilbage til Shopifys egen server-validering.
     ====================================================================== */

  function errorFor(field) {
    var v = field.validity;
    if (!v || v.valid) return '';
    if (v.valueMissing) return field.getAttribute('data-nb-error-required') || '';
    if (v.typeMismatch || v.patternMismatch) return field.getAttribute('data-nb-error-email') || '';
    return field.getAttribute('data-nb-error-required') || '';
  }

  function fieldMessageEl(field) {
    var id = field.getAttribute('aria-describedby');
    if (!id) return null;
    return document.getElementById(id.split(' ')[0]);
  }

  function showFieldError(field, message) {
    field.setAttribute('aria-invalid', message ? 'true' : 'false');
    var el = fieldMessageEl(field);
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }

  function initForms(root) {
    toArray(scopeOf(root).querySelectorAll('form[data-nb-validate]')).forEach(function (form) {
      if (!claim(form)) return;

      form.setAttribute('novalidate', '');
      var summary = form.querySelector('[data-nb-form-errors]');

      function fields() {
        return toArray(form.querySelectorAll('input, textarea, select')).filter(function (el) {
          return el.willValidate;
        });
      }

      function clearSummary() {
        if (!summary) return;
        summary.textContent = '';
        summary.hidden = true;
      }

      fields().forEach(function (field) {
        field.addEventListener('blur', function () {
          if (field.getAttribute('aria-invalid') !== 'true' && field.value === '') return;
          showFieldError(field, errorFor(field));
        });
        field.addEventListener('input', function () {
          if (field.getAttribute('aria-invalid') !== 'true') return;
          if (field.checkValidity()) {
            showFieldError(field, '');
            clearSummary();
          }
        });
      });

      form.addEventListener('submit', function (event) {
        var invalid = null;
        fields().forEach(function (field) {
          var message = errorFor(field);
          showFieldError(field, message);
          if (message && !invalid) invalid = field;
        });

        if (!invalid) {
          clearSummary();
          return;
        }

        event.preventDefault();
        if (summary) {
          summary.textContent = summary.getAttribute('data-nb-message') || '';
          summary.hidden = false;
        }
        invalid.focus();
      });
    });
  }

  /* ======================================================================
     3) Cookie-banneret kan genaabnes fra cookiepolitik-siden
     ====================================================================== */

  function initCookieButtons(root) {
    toArray(scopeOf(root).querySelectorAll('[data-nb-cookie-reopen]')).forEach(function (button) {
      if (!claim(button)) return;
      button.addEventListener('click', function () {
        if (window.NBCookie && typeof window.NBCookie.reopen === 'function') {
          window.NBCookie.reopen();
        }
      });
    });
  }

  /* ======================================================================
     4) Init
     ====================================================================== */

  function init(root) {
    initTabs(root);
    initForms(root);
    initCookieButtons(root);
  }

  if (!window.__nbPagesBound) {
    window.__nbPagesBound = true;
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target || document);
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }
  } else {
    init(document);
  }

  window.NBPages = { init: init };
})();
